import { withTheme } from 'styled-components';
import { GoogleStaticMap } from './GoogleStaticMap';

const ThemedGoogleStaticMap = withTheme(GoogleStaticMap);

export {
    ThemedGoogleStaticMap as default,
    ThemedGoogleStaticMap as GoogleStaticMap,
    GoogleStaticMap as BaseGoogleStaticMap,
};
